/**
 * <strong>Purpose:</strong> <br><br>
 * Provides the ability to flip the editable-ity of an input-type widget(textfield, textarea)
 * It is similar to disabled property in that it blocks user input, but different that it allows content selection via the mouse(mouse-down and drag).
 * <br><br>
 * <strong>Attach-point Dependencies:</strong> <br><br>
 * <li>inputNode</li> <br><br>
 *
 *  @module mw-form/mixins/property/EditableMixin
 *
 * @copyright Copyright 2014 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare"
], function (declare) {

    return declare(null, {

        /**
         * @property  {boolean} editable - Supported Values: true/false
         * @instance
         * @default
         */
        editable: true,

        postCreate: function () {
            this.inherited(arguments);
            this.domNode.classList.add("mwEditableMixin");
            // When the default value is falsy, the setter will not be triggered during the widget's construction phase
            // We need to call the setter explicitly
            this._setEditableAttr(this.get("editable"));
        },

        _setEditableAttr: function (value) {
            this.inputNode.readOnly = !value;
            /* Add or remove mwEditable class based on value*/
            if (value) {
                this.domNode.classList.remove("mwNonEditable");
            } else {
                this.domNode.classList.add("mwNonEditable");
            }
            this._set("editable", value);
        }
    });

});
